<ion-toolbar>
  <ion-title>{{ title }}</ion-title>
  <div slot="end">
    <ion-button size="small" fill="clear" color="light" (click)="close()">
      <ion-icon name="close"></ion-icon>
    </ion-button>
  </div>
</ion-toolbar>
